export default "__VITE_ASSET__D$ROArzr__"